import * as angular from "angular";
import {IController} from "angular";
import {TaskStatusType} from "../../types/taskStatus.type";
import {TaskModel} from "../../models/task.model";

export class taskPrintInfoCtrl implements IController {

  task: TaskModel;

  public taskStatusType: typeof TaskStatusType = TaskStatusType;

  constructor() {
  }


}

angular
  .module('bringoz.admin.tasks')
  .component('taskPrintInfo', {
    bindings: {
      task: '<'
    },
    template: require('./task-print-info.html').default,
    controller: taskPrintInfoCtrl
  });
